import React, { useEffect, useMemo, useState } from "react";
import {
  FavoriteContent,
  FavoriteTabButton,
  FavoriteTabContainer,
} from "./styled";
import NothingFound from "../../components/NothingFound";
import { Center } from "../../App/styled";
import Loader from "../../components/Loader/Loader";
import PageContainer from "../../components/PageContainer";
import FavoriteList from "../../components/FavoriteList/FavoriteList";
import {
  podcastsApi,
  useGetFavoritePodcastsTracksInfiniteQuery,
} from "../../api/podcastsApi";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectCurrentEntity,
} from "../../redux/selectors/playerSelector";
import { EmptyFavorite } from "../../components/EmptyFavorite";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useGetFavoriteTracksInfiniteQuery } from "../../api/tracksApi";

const TABS = {
  PODCASTS: "podcasts",
  TRACKS: "tracks",
};

export const FavoritePage = () => {
  const currentEntity = useSelector(selectCurrentEntity);
  const currentContent = useSelector(selectCurrentContent);
  const [favoriteTracksArgs, setFavoriteTracksArgs] = useState({
    currentTrackId: undefined,
  });
  const [activeTab, setActiveTab] = useState("podcasts");

  const isMobile = useMediaQuery("(max-width: 900px)");

  const {
    data: podcastTracksData,
    isError: isPodcastTracksError,
    isLoading: isPodcastTracksLoading,
    fetchNextPage: handleNextPagePodcastTracks,
  } = useGetFavoritePodcastsTracksInfiniteQuery();
  const {
    data: tacksData,
    isError: isTracksError,
    isLoading: isTracksLoading,
    fetchNextPage: handleNextPageTracks,
  } = useGetFavoriteTracksInfiniteQuery(favoriteTracksArgs);

  const dispatch = useDispatch();

  const favoritePodcastTracks = useMemo(
    () => podcastTracksData?.pages.flat()[0] || [],
    [podcastTracksData?.pages],
  );
  const favoriteTracks = useMemo(
    () => tacksData?.pages.flat()[0] || [],
    [tacksData?.pages],
  );

  const favoriteData = useMemo(
    () => [
      {
        keys: TABS.PODCASTS,
        title: "Любимые выпуски",
        data: favoritePodcastTracks.podcastReleases,
        handleNextPage: handleNextPagePodcastTracks,
      },
      {
        keys: TABS.TRACKS,
        title: "Любимая музыка",
        data: favoriteTracks.tracks,
        handleNextPage: handleNextPageTracks,
        isRelease: false,
      },
    ],
    [
      favoritePodcastTracks.podcastReleases,
      favoriteTracks.tracks,
      handleNextPagePodcastTracks,
      handleNextPageTracks,
    ],
  );

  useEffect(() => {
    return () => {
      dispatch(podcastsApi.util.invalidateTags(["favoriteTracks"]));
      dispatch(podcastsApi.util.invalidateTags(["favoritePodcastsTracks"]));
    };
  }, [dispatch]);

  useEffect(() => {
    if (currentEntity === "track") {
      setFavoriteTracksArgs({
        currentTrackId: currentContent.id,
      });
    }
  }, [currentContent.id, currentEntity]);

  if (isTracksLoading || isPodcastTracksLoading) {
    return (
      <Center>
        <Loader color="#fff" />
      </Center>
    );
  }

  if (isTracksError || isPodcastTracksError) {
    return <NothingFound />;
  }

  const hasFavoritePodcasts = favoritePodcastTracks.podcastReleases?.length > 0;
  const hasFavoriteTracks = favoriteTracks.tracks?.length > 0;

  if (!isMobile && !hasFavoritePodcasts && !hasFavoriteTracks) {
    return <EmptyFavorite withInfo />;
  }

  const renderFavoriteContent = () => {
    const showPodcasts = activeTab === TABS.PODCASTS;

    const filteredData = isMobile
      ? favoriteData.filter((item) =>
          showPodcasts
            ? item.keys === TABS.PODCASTS
            : item.keys === TABS.TRACKS,
        )
      : favoriteData;

    return (
      <FavoriteContent>
        {filteredData.map((item) => (
          <FavoriteList key={item.title} {...item} />
        ))}
      </FavoriteContent>
    );
  };

  return (
    <PageContainer>
      {isMobile && (
        <FavoriteTabContainer>
          <FavoriteTabButton
            active={activeTab === TABS.PODCASTS}
            onClick={() => setActiveTab(TABS.PODCASTS)}
          >
            Любимые выпуски
          </FavoriteTabButton>
          <FavoriteTabButton
            active={activeTab === TABS.TRACKS}
            onClick={() => setActiveTab(TABS.TRACKS)}
          >
            Любимая музыка
          </FavoriteTabButton>
        </FavoriteTabContainer>
      )}
      {renderFavoriteContent()}
    </PageContainer>
  );
};
